import styled, { css } from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';
import { INLINE_CONTROL_MIN_HEIGHT } from 'pages/ConfigurePage/ConfigureForm/QuestionRow/QuestionRow.styled';

interface StyledProps {
  isStacked: boolean;
}

export const RadioGroupRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  // Carries the shared line height so the group centres against the question
  // name whatever size MUI renders the radios at.
  min-height: ${INLINE_CONTROL_MIN_HEIGHT}rem;

  // A stacked group runs down the row, so the clear button aligns with the
  // question name and the first option instead of with the group's centre.
  ${(props: StyledProps) =>
    props.isStacked &&
    css`
      align-items: flex-start;

      .MuiFormControlLabel-root:first-of-type {
        min-height: ${INLINE_CONTROL_MIN_HEIGHT}rem;
      }

      > div:last-child {
        min-height: ${INLINE_CONTROL_MIN_HEIGHT}rem;
      }
    `};

  // Claiming the full width from smallTablet down pushes the group onto its own
  // line below the question name, still right aligned. Sharing the line there
  // would leave two or three option labels crowded against the name.
  ${respondTo.smallTablet`
    width: 100%;
    min-height: 0;

    .MuiFormControlLabel-root:first-of-type {
      min-height: 0;
    }

    > div:last-child {
      min-height: 0;
    }
  `};
`;
